import { DATA_OPERATION } from 'store/enums';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  customerType: DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR,
  flux: DATA_OPERATION.FLUX.TESLA,
  prospect: {
    contact: [
      {
        contactType: DATA_OPERATION.CONTACT_TYPE.CONTACT,
        documentType: 0,
        documentId: '',
        name: '',
        lastname: '',
        lastname2: '',
        genre: '',
        maritalStatus: null,
        jobType: null,
        address: {
          streetType: '',
          address1: '',
          postalCode: '',
          provinceCode: '',
          cityCode: ''
        },
        email: '',
        phone: '',
        mobile: '',
        chkRobinson: false,
        chkTermsAndConditions: false,
        chkDataTransfer: false,
        chkProactive: false,
        birthDate: '',
        signType: '',
        driverLicenseIssuedDate: ''
      }
    ]
  },
  renovationPlate: '',
  signRequest: {
    bankAccount: '',
    billingAgreementId: '',
    tokenStripe: '',
    electronicId: '',
    delivery: {
      provinceCode: '',
      postalCode: '',
      date: ''
    }
  },
  user: 'TESLA'
  // operationOwner: '',
  // marketPlaceOrderId: ''
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
